"use client";

import Link from "next/link";
import { usePublicPathname } from "@/app/hooks/use-public-pathname";
import * as Logos from "../logos";
import { getBrandConfig, isBrandPath } from "@/app/config/brand-registry";

export default function LogoRow() {
  const pathname = usePublicPathname();
  const isAudiPath = isBrandPath(pathname, "audi");

  // Im Audi-Auftritt führt das Wiest-Logo auf die Audi-Startseite statt auf
  // die Konzern-Startseite — identisch zur Navbar (logoHref dort).
  const wiestLogoHref = isAudiPath ? getBrandConfig("audi").routePrefix : "/";

  return (
    <div className="flex flex-wrap items-center justify-start gap-x-3 gap-y-4 sm:gap-4">
      <Link
        aria-label={isAudiPath ? "Zur Audi Startseite" : "Zur Startseite"}
        href={wiestLogoHref}
      >
        <Logos.WiestLogoWhite className="w-[100px] sm:mr-2" />
      </Link>

      <Link
        href="https://www.audi-zentrum-darmstadt.audi/de.html"
        target="_blank"
        aria-label="Audi"
        rel="noopener noreferrer"
        className="inline-block transition-opacity hover:opacity-80"
      >
        <Logos.AudiLogo fill="white" width={60} height={40} />
      </Link>

      {!isAudiPath && (
        <>
          <Link
            href="https://www.volkswagen.de/de/haendler-werkstatt/autohaus-j-wiest-soehne-darmstadt.html"
            target="_blank"
            aria-label="Volkswagen"
            rel="noopener noreferrer"
            className="inline-block transition-opacity hover:opacity-80"
          >
            <Logos.VolkswagenLogo fill="white" />
          </Link>

          <Link
            href="https://www.porsche-darmstadt.de/"
            target="_blank"
            aria-label="Porsche"
            rel="noopener noreferrer"
            className="inline-block transition-opacity hover:opacity-80"
          >
            <Logos.PorscheLogo fill="white" width={120} height={30} />
          </Link>

          <Link
            href="https://darmstadt.skoda-auto.de/"
            target="_blank"
            aria-label="Skoda"
            rel="noopener noreferrer"
            className="inline-block transition-opacity hover:opacity-80"
          >
            <Logos.SkodaLogo fill="white" width={80} height={40} />
          </Link>

          <Link
            href="https://www.volkswagen-nutzfahrzeuge.de/de/haendler-werkstatt/j-wiest-soehne-darmstadt.html"
            target="_blank"
            aria-label="VolkswagenNutzfahrzeuge"
            rel="noopener noreferrer"
            className="inline-block transition-opacity hover:opacity-80"
          >
            <Logos.NfzLogo fill="white" width={40} height={35} />
          </Link>

          <Logos.SeatLogo fill="white" width={50} height={35} />
          <Logos.CupraLogo fill="white" width={50} height={35} />
        </>
      )}
    </div>
  );
}
